import { render } from "./DoctorList.vue?vue&type=template&id=09b8df7c&scoped=true&ts=true"
import script from "./DoctorList.vue?vue&type=script&lang=ts"
export * from "./DoctorList.vue?vue&type=script&lang=ts"

import "./DoctorList.vue?vue&type=style&index=0&id=09b8df7c&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b8df7c"]])

export default __exports__